import documentReviewManagerKPIs from "./documentReviewManagerKPIs";
import documentReviewReviewerKPIs from "./documentReviewReviewerKPIs";
import applicationManagerKPIs from "./applicationManagerKPIs";
import applicationSecondReviewerKPIs from "./applicationSecondReviewerKPIs";
import applicationReviewerKPIs from "./applicationReviewerKPIs";
import inspectorKPIs from "./inspectorKPIs";

const kpiService = [
    {
        matcher: 'documentReviewManagerKPIs',
        reply: config => {
            return [200, documentReviewManagerKPIs];
        }
    },
    {
        matcher: 'documentReviewReviewerKPIs',
        reply: config => {
            return [200, documentReviewReviewerKPIs];
        }
    },
    {
        matcher: 'applicationManagerKPIs',
        reply: config => {
            return [200, applicationManagerKPIs];
        }
    },
    {
        matcher: 'applicationSecondReviewerKPIs',
        reply: config => {
            return [200, applicationSecondReviewerKPIs];
        }
    },
    {
        matcher: 'applicationReviewerKPIs',
        reply: config => {
            return [200, applicationReviewerKPIs];
        }
    },
    {
        matcher: 'inspectorKPIs',
        reply: config => {
            return [200, inspectorKPIs];
        }
    },
]

export default kpiService;